<template>
  <div
    class="px-4"
    style="margin-top: 100px"
  >
    <v-card class="py-4 login-card">
      <v-form
        id="formLogin"
        v-model="valid"
        @submit="login"
      >
        <div class="text-xs-center">
          <v-snackbar
            v-model="snackbar"
            class="snackBar"
            :color="color"
            :top="true"
            :multi-line="true"
          >
            <v-icon
              small
              color="red"
              style="margin-right: 15px"
            >
              fas fa-exclamation-circle
            </v-icon>
            {{ text }}
            <v-btn
              class="snackbar-btn"
              width="675px"
              outline
              @click="snackbar = false"
            >
              Ok
            </v-btn>
          </v-snackbar>
          <v-layout
            pa-2
            class="lightbox white--text"
          >
            <v-flex>
              <div class="cabecalho animated fadeIn delay-1s d-flex align-center justify-center">
                <v-img
                  :src="require(`../assets/crmlogo.svg`)"
                  contain
                  max-width="188px"
                />
              </div>

              <v-layout
                align-center
                justify-center
                row
              >
                <v-flex
                  xs10
                  lg3
                  class="margin-to-top animated fadeInUp delay-1s"
                >
                  <v-text-field
                    v-model="user"
                    label="E-mail"
                    prepend-icon="$vuetify.icons.userIcon"
                    clearable
                    :rules="[rules.required]"
                    @click:clear="limparForm"
                  />
                </v-flex>
              </v-layout>

              <v-layout
                align-center
                justify-center
                row
              >
                <v-flex
                  xs10
                  lg3
                  class="animated fadeInUp delay-1s"
                >
                  <v-text-field
                    v-model="password"
                    label="Senha"
                    prepend-icon="vpn_key"
                    :append-icon="show ? 'visibility' : 'visibility_off'"
                    :type="show ? 'text' : 'password'"
                    :rules="[rules.required, rules.min]"
                    @click:append="show = !show"
                  />
                </v-flex>
              </v-layout>

              <v-flex class="mt-4">
                <v-btn
                  :loading="loading"
                  type="submit"
                  color="primary"
                  class="animated fadeInLeft delay-1s login-btn"
                >
                  <span>Login</span>
                </v-btn>
              </v-flex>

              <v-flex class="mt-5 animated fadeIn delay-2s forgot-password-txt">
                <a @click="redirectToWhatsapp">Esqueceu a senha?</a>
              </v-flex>
            </v-flex>
          </v-layout>
        </div>
      </v-form>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      valid: null,
      snackbar: false,
      text: '',
      color: '',
      show: false,
      user: null,
      password: '',
      loading: false,
      rules: {
        required: (value) => !!value || 'Campo Obrigatorio',
        min: (v) => (v && v.length >= 6) || 'Minimo de 6 caracteres',
      },
    };
  },
  methods: {
    redirectToWhatsapp() {
      const text = encodeURI('Olá! Preciso de ajuda.');
      window.open(`https://wa.me/+5511910751953?text=${text}`, '_blank');
    },

    limparForm() {
      this.password = '';
    },
    login(e) {
      e.preventDefault();
      if (this.loading || !this.valid) return;

      this.loading = true;

      this.$auth.newLogin(this.user, this.password, (err) => {
        if (err && err.code == 'invalid_grant') {
          this.color = '#ffffff';
          this.text = 'E-mail ou senha incorretos.';
          this.snackbar = true;
          console.log('Error', err);
        } else if (err) {
          this.color = '#ffffff';
          this.text = 'Ocorreu um erro, por favor tente novamente mais tarde.';
          this.snackbar = true;
          console.log('Error', err);
        }
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  a {
    color: #000000;
  }

  .cabecalho {
    margin-top: 50px;
  }

  .login-card {
    border-radius: 8px;
  }

  .dialog {
    &__close {
      display: flex;
      justify-content: end;
    }
    &__title {
      font-size: 24px;
      font-weight: 700;
      padding: 0 2rem;
      margin-bottom: 1.5rem;
    }
    &__text {
      font-size: 14px;
      padding: 0 2rem;
    }
    &__emphasis {
      font-weight: 700;
    }
    &__confirm {
      display: flex;
      justify-content: center;
    }
    &__btn {
      margin: 1rem 0;
      text-transform: none;
      padding: 0.75rem 4rem;
      border-radius: 7px;
    }
  }

  ::v-deep .snackBar {
    color: red !important;
    caret-color: red !important;
    text-align: left !important;
    box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.1) !important;
  }

  ::v-deep .v-input .v-label {
    font-family: 'Neue-Metana' !important;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 15px;
  }

  .icon-cabecalho {
    font-size: 40px !important;
    padding-right: 4px;
    padding-bottom: 10px;
  }
  .margin-to-top {
    margin-top: 80px;
  }
  .login-btn{
    border-radius: 7.08982px;
    font-family: 'Neue-Metana';
    font-style: normal;
    font-weight: normal;
    font-size: 8.68576px;
  }
  .snackbar-btn {
    border-radius: 7.08982px;
      color: red !important;
    caret-color: red !important;
    min-width: 83px !important;
  }
  .margin-to-bottom {
    margin-top: 160px;
  }
  .overflow {
    overflow-y: hidden;
  }
  .forgot-password-txt {
  font-family: 'Nunito sans', serif;
  margin-bottom: 50px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  text-decoration-line: underline;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    border: transparent;
    -webkit-text-fill-color: white;
    -webkit-box-shadow: 0 0 0px 1000px transparent inset;
    transition: background-color 5000s ease-in-out 0s;
  }
</style>
